import React from 'react'
import { Subscriber } from 'react-broadcast'

const User = ({ render }) => <Subscriber channel="user">{render}</Subscriber>

export default User



// WEBPACK FOOTER //
// ./src/components/User/index.js